/**
 * Event bus phát tín hiệu mỗi khi có mutation (POST/PUT/PATCH/DELETE) thành công
 * trên `apiClient`. Các list view có thể đăng ký lắng nghe để tự reload data
 * mà không cần component cha gọi `loadData()` thủ công.
 */

export interface DataChangedEvent {
  method: 'POST' | 'PUT' | 'PATCH' | 'DELETE'
  /** URL đầy đủ của request (vd: `/customers/9`, `/hr/employees`) */
  url: string
}

type Listener = (e: DataChangedEvent) => void

const listeners = new Set<Listener>()

export const dataBus = {
  emit(e: DataChangedEvent) {
    listeners.forEach((l) => {
      try { l(e) } catch (err) { console.error('dataBus listener error:', err) }
    })
  },
  on(listener: Listener): () => void {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
}
